import { render, staticRenderFns } from "./SchemaListItem.vue?vue&type=template&id=3217afa4&"
import script from "./SchemaListItem.vue?vue&type=script&lang=js&"
export * from "./SchemaListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports